import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import ContactFormFields from './ContactFormFields';
import { ContactShape } from '../../../../../models/Contact';

const checkIfLastEntryIsDirty = (contacts) => {
  if (contacts.length === 0) return true;

  const lastContact = contacts[contacts.length - 1];
  return !!(lastContact && (lastContact.name || lastContact.phoneNumber || lastContact.email));
};

const ContactsFormFields = ({ values, setFieldValue, zoneId }) => {
  const handleDeleteClick = useCallback(
    (contactIndex) => {
      const filteredContacts = values.contacts;
      filteredContacts.splice(contactIndex, 1);
      setFieldValue('contacts', filteredContacts);
    },
    [setFieldValue, values.contacts]
  );

  useEffect(() => {
    if (checkIfLastEntryIsDirty(values.contacts)) {
      setFieldValue(`contacts.${values.contacts.length}`, {
        zoneId,
        name: '',
        phoneNumber: '',
        email: '',
      });
    }
  }, [setFieldValue, values.contacts, zoneId]);

  return values.contacts.map((contact, index) => (
    <ContactFormFields key={`${String(index)}-contact`} index={index} contactsLength={values.contacts.length} onDeleteClick={handleDeleteClick} />
  ));
};

ContactsFormFields.propTypes = {
  values: PropTypes.shape({ contacts: PropTypes.arrayOf(ContactShape) }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  zoneId: PropTypes.string.isRequired,
};

export default ContactsFormFields;
